module.exports = {
      id: "login-usage",
      viewBox: "0 0 14.742 20.333",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#login",
      toString: function () {
        return this.url;
      }
    }